import { RouterProvider } from "react-router-dom";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { ROUTE_NAMES, USER_TYPES } from "@root/constants";
import { publicRoutes } from "./publicRoutes";
import { adminRoutes } from "./adminRoutes";
import { superAdminRoutes } from "./superAdminRoutes";
import { pledgingRoutes } from "./pledgingRoutes";
import { journalistRoutes } from "./journalistRoutes";
import React, { useState, useEffect } from "react";

const Router = () => {
  const isLoggedInUser: any = useSelector(getLoggedInUser);
  const [delayedUser, setDelayedUser] = useState(isLoggedInUser);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const getLoginRoute = (userRole: number) => {
    switch (userRole) {
      case USER_TYPES.SUPER_ADMIN:
        return ROUTE_NAMES.SUPER_ADMIN_LOGIN;
      case USER_TYPES.ADMIN:
        return ROUTE_NAMES.ADMIN_LOGIN;
      case USER_TYPES.SUBSCRIBER:
      case USER_TYPES.NON_SUBSCRIBER:
      case USER_TYPES.SUBSUBSCRIBER:
        return ROUTE_NAMES.PLEDGE_LOGIN;
      case USER_TYPES.JOURNALIST:
        return ROUTE_NAMES.LOGIN;
      default:
        return ROUTE_NAMES.LOGIN;
    }
  };

  useEffect(() => {
    if (isLoggedInUser !== delayedUser) {
      if (!delayedUser && isLoggedInUser) {
        setDelayedUser(isLoggedInUser);
        return;
      }

      if (delayedUser && !isLoggedInUser) {
        setIsTransitioning(true);
        const timer = setTimeout(() => {
          setDelayedUser(isLoggedInUser);
          setIsTransitioning(false);

          const loginRoute = getLoginRoute(delayedUser?.role);
          window.history.pushState({}, "", loginRoute);
          window.dispatchEvent(new PopStateEvent("popstate"));
        }, 100);

        return () => clearTimeout(timer);
      }

      setDelayedUser(isLoggedInUser);
    }
  }, [isLoggedInUser, delayedUser]);

  const getRouterElement = () => {
    if (delayedUser?.role === USER_TYPES.SUPER_ADMIN) {
      return <RouterProvider router={superAdminRoutes} />;
    } else if (delayedUser?.role === USER_TYPES.ADMIN) {
      return <RouterProvider router={adminRoutes} />;
    } else if (delayedUser?.role === USER_TYPES.JOURNALIST) {
      return <RouterProvider router={journalistRoutes} />;
    } else if (
      delayedUser?.role === USER_TYPES.SUBSCRIBER ||
      delayedUser?.role === USER_TYPES.SUBSUBSCRIBER ||
      delayedUser?.role === USER_TYPES.NON_SUBSCRIBER
    ) {
      return <RouterProvider router={pledgingRoutes} />;
    } else {
      return <RouterProvider router={publicRoutes} />;
    }
  };

  if (isTransitioning) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
          color: "#666",
        }}
      >
        Logging out...
      </div>
    );
  }

  return getRouterElement();
};

export default Router;
